import {CoreBaseEffects} from "@core/core-base.effects";
import {Store} from "@ngrx/store";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {ILocalPageOutputDto} from "@shared/interfaces/orga-response.interface";
import {KnowledgeArticleListDto, KnowledgeExamAnswerDto} from '@server-models';
import {SharedKnowledgeActions} from "./knowledge.actions-type";
import {ISharedLocalBodyRequest} from "@shared/interfaces/shared-local-body-request.interface";

@Injectable({
  providedIn: 'root'
})
export abstract class SharedKnowledgeEffectsBase extends CoreBaseEffects {

  protected constructor(store: Store, rawActions$: Actions) {
    super(store, rawActions$);
  }

  abstract getPath(action$: Observable<ISharedLocalBodyRequest>): Observable<any>;

  abstract getKnowledgePathById(action$: Observable<any>): Observable<any>;

  abstract getItemsSearched(action$: Observable<{
    toSearch: string
  }>): Observable<ILocalPageOutputDto<KnowledgeArticleListDto[]> | any>;

  abstract getArticlePage(action$: Observable<any>): Observable<any>;

  abstract getExamAnswerById(action$: Observable<any>): Observable<KnowledgeExamAnswerDto | any>;

  abstract submitExamAnswer(action$: Observable<{
    exam: KnowledgeExamAnswerDto
  }>): Observable<KnowledgeExamAnswerDto | any>;


  getPath$ = createEffect(() => this.actions().pipe(
    ofType(SharedKnowledgeActions.getPathItemsPaged),
    action => this.getPath(action)
  ));

  getKnowledgePathById$ = createEffect(() => this.actions().pipe(
    ofType(SharedKnowledgeActions.getKnowledgePathById),
    action => this.getKnowledgePathById(action)
  ));

  getItemsSearched$ = createEffect(() => this.actions().pipe(
    ofType(SharedKnowledgeActions.getItemsSearched),
    action => this.getItemsSearched(action)
  ));

  getArticlePage$ = createEffect(() => this.actions().pipe(
    ofType(SharedKnowledgeActions.getArticlePage),
    action => this.getArticlePage(action)
  ));

  getExamById$ = createEffect(() => this.actions().pipe(
    ofType(SharedKnowledgeActions.getExamAnswerById),
    action => this.getExamAnswerById(action)
  ))

  submitExamAnswer$ = createEffect(() => this.actions().pipe(
    ofType(SharedKnowledgeActions.submitExamAnswer),
    action => this.submitExamAnswer(action)
  ))

}
